import React from "react";
const documentDirections = ["ltr", "rtl"];
export function isDirection(dir) {
    return documentDirections.includes(dir);
}
export const DirectionContext = React.createContext(null);
//# sourceMappingURL=contexts.js.map